export default __webpack_public_path__ + "static/media/IMG5564.f4038498.jpg";